var _rect, _rect2, _path, _path2, _rect3, _path3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScheduleLarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.969,
    height: 18,
    viewBox: "0 0 17.969 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2.478,
    transform: "translate(3.665)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2.478,
    transform: "translate(10.503)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8,32.609A4.2,4.2,0,1,0,18,36.8,4.2,4.2,0,0,0,13.8,32.609ZM13.8,40A3.2,3.2,0,1,1,17,36.8,3.2,3.2,0,0,1,13.8,40Z",
    transform: "translate(-0.03 -23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3,34.087h-1V36.8a.5.5,0,0,0,.147.354l1.832,1.832.707-.707L14.3,36.6Z",
    transform: "translate(-0.031 -23)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.789,
    height: 1,
    transform: "translate(5.139 0.739)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03,26.957H14.043v4.492h1v-7.71H12.131v1h1.912v1.218H1.03V24.739H3.08v-1H.03V37.3H8.471v-1H1.03Z",
    transform: "translate(-0.03 -23)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.283,
    height: 1.283,
    transform: "translate(2.829 5.133)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.283,
    height: 1.283,
    transform: "translate(2.829 7.7)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.283,
    height: 1.283,
    transform: "translate(2.829 10.266)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.283,
    height: 1.283,
    transform: "translate(5.395 5.133)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.283,
    height: 1.283,
    transform: "translate(5.395 7.7)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.283,
    height: 1.283,
    transform: "translate(5.395 10.266)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 1.283,
    height: 1.283,
    transform: "translate(7.962 5.133)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 1.283,
    height: 1.283,
    transform: "translate(7.962 7.7)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.283,
    height: 1.283,
    transform: "translate(10.528 5.133)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule-large.e849dbbd6277795c15173dda4d27bf5d.svg";